import { Navigate, useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { isFormEnabled, config } from "./config"
import type { FormRouteKey } from "./config"

interface FormGuardProps {
  /** The route key identifying this form */
  formKey: FormRouteKey
  /** The actual form element to render when the form is enabled */
  children: React.ReactNode
}

/**
 * Wrapper that checks whether a form is enabled via configuration.
 * If the form is disabled, the user is redirected to the form specified
 * by the VITE_FORM_DISABLED_REDIRECT environment variable (default: "invoicing").
 */
const FormGuard = ({ formKey, children }: FormGuardProps) => {
  const { lang } = useParams<{ lang: string }>()
  const { t } = useTranslation()

  if (isFormEnabled(formKey)) {
    return <>{children}</>
  }

  // Redirect to the configured fallback form
  const redirectKey = config.formDisabledRedirect as FormRouteKey
  const canonicalPath = t(`routes.${redirectKey}.canonical`)
  return <Navigate to={`/${lang}/${canonicalPath}`} replace />
}

export default FormGuard
